import { Epic, ofType } from 'redux-observable'
import { mergeMap, filter } from 'rxjs/operators'
import { getProjectRules } from '../infrastructure/api/project-rules'
import { ProjectRulesResponse } from '../domain/value-object/ProjectRulesVO'
import { featureFlagService } from '../utils/feature-flag'

enum ActionType {
  FETCH_PROJECT_RULES = 'FETCH_PROJECT_RULES',
  RECEIVED_PROJECT_RULES = 'RECEIVED_PROJECT_RULES',
  CLEAR_PROJECT_RULES = 'CLEAR_PROJECT_RULES',
}

type State = {
  rules: ProjectRulesResponse | undefined
}

export const fetchProjectRules = () => ({
  type: ActionType.FETCH_PROJECT_RULES,
})

export const receivedProjectRules = (rules: ProjectRulesResponse) => ({
  type: ActionType.RECEIVED_PROJECT_RULES,
  rules,
})

export const clearProjectRules = () => ({
  type: ActionType.CLEAR_PROJECT_RULES,
})

export const fetchProjectRulesEpic: Epic<any, any> = action$ =>
  action$.pipe(
    ofType(ActionType.FETCH_PROJECT_RULES),
    filter(() => featureFlagService.isEnabled('sprints-multi-select')),
    mergeMap(async () => {
      try {
        const rules = await getProjectRules()
        return receivedProjectRules(rules)
      } catch {
        return { type: 'NO_OP' }
      }
    })
  )

export const reducer = (
  state: State = { rules: undefined },
  action: any
): State => {
  switch (action.type) {
    case ActionType.RECEIVED_PROJECT_RULES:
      return { ...state, rules: action.rules }
    case ActionType.CLEAR_PROJECT_RULES:
      return { ...state, rules: undefined }
    default:
      return state
  }
}
